import toLower from "mn-utils/toLower";
import parseCryptoToken from "../../../../../utils/parseCryptoToken";
import {pushLocation} from "../../../../../router";
import * as links from "../../../../../constants/links";
import generatePBLReceipt from "./generatePBLReceipt";
import openPopupCancel from "../openPopupCancel";
import map from "mn-utils/map";
import React from "react";

export const generateActionsList = (data, update) => {
  const STATUS_SENT = 'sent';
  const STATUS_PAID = 'paid';
  const STATUS_DRAFT = 'draft';

  const {
    orderId,
    transactionKind,
    paymentId,
    auctionId,
    invoiceId,
    refundId,
    currencyCode,
    status,
  } = data;

  return [
    status === STATUS_DRAFT ? {
      name: 'Edit',
      onClick() {
        pushLocation({
          path: `${links.LINK_PBL}/${invoiceId}`,
        });
      },
    } : {
      name: 'Details',
      onClick() {
        let path = `${links.LINK_PBL_DETAILS}/${invoiceId}`;
        if (auctionId) {
          path += `/${auctionId}`;
        }

        if (transactionKind === 'refund') {
          path = `${links.LINK_REFUND_DETAILS}/${refundId}`
        }

        pushLocation({path});
      },
    },
    ...(status !== STATUS_DRAFT ? [{
      name: 'Receipt',
      onClick() {
        generatePBLReceipt(data);
      },
    }] : []),
    ...(status === STATUS_PAID && orderId && paymentId && currencyCode !== 'KLUB' ? [{
      name: 'Refund',
      onClick() {
        pushLocation({
          path: `${links.LINK_PBL_REFUND}/${orderId}/${paymentId}`,
        });
      },
    }] : []),
    ...(status === STATUS_SENT ? [{
      name: (<div className="cF00">Cancel</div>),
      onClick() {
        openPopupCancel(data, update);
      },
    }] : []),
  ];
}
